import {
  AuthActions,
  Selectors,
  useWidgetDispatch,
  useWidgetState,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {useCallback, useEffect} from 'react';
import React from 'react';

import LeaderBoardPreferences from 'components/LeaderboardPreferences';

const ConnectedLeaderBoardPreferences = () => {
  const widgetDispatch = useWidgetDispatch();
  const leaderBoardDisplayStatus = useWidgetState(
    Selectors.leaderBoardStatusSelector
  ) as boolean;

  useEffect(() => {
    widgetDispatch(AuthActions.getLeaderBoardStatus());
  }, [widgetDispatch]);

  const handleSetLeaderBoardStatus = useCallback(() => {
    widgetDispatch(AuthActions.setLeaderBoardStatus(!leaderBoardDisplayStatus));
  }, [leaderBoardDisplayStatus, widgetDispatch]);

  return (
    <LeaderBoardPreferences
      onSetStatus={handleSetLeaderBoardStatus}
      status={leaderBoardDisplayStatus}
    />
  );
};

export default ConnectedLeaderBoardPreferences;
